
  const skills = new Bloodhound({
    datumTokenizer: Bloodhound.tokenizers.obj.whitespace('Label'),
    queryTokenizer: Bloodhound.tokenizers.whitespace,
    remote: {
      url: '/HandlerLeark.ashx?take=10&method=searchSuggestionsSimpleJson&txt=%QUERY',
      wildcard: '%QUERY'
    }
  })

  const cities = new Bloodhound({
    datumTokenizer: Bloodhound.tokenizers.obj.whitespace('Label'),
    queryTokenizer: Bloodhound.tokenizers.whitespace,
    remote: {
      url: '/HandlerLeark.ashx?method=citiesByDistrictJson&txt=%QUERY',
      wildcard: '%QUERY'
    }
  })

  const country = new Bloodhound({
    datumTokenizer: Bloodhound.tokenizers.obj.whitespace('Label'),
    queryTokenizer: Bloodhound.tokenizers.whitespace,
    remote: {
      url: '/HandlerLeark.ashx?method=countryJson&txt=%QUERY',
      wildcard: '%QUERY'
    }
  })

  const district = new Bloodhound({
    datumTokenizer: Bloodhound.tokenizers.obj.whitespace('Label'),
    queryTokenizer: Bloodhound.tokenizers.whitespace,

    remote: {
      url: '/HandlerLeark.ashx?method=districtJson&txt=%QUERY',
      wildcard: '%QUERY'
    }
  })

  Vue.prototype.dynFormConfigPaymentType = [
    {
      id: 0,
      fieldName: 'rblPaymentType',
      label: `Carta di credito`,
      inputType: 'radio',
      value: 'CC',
      valueIfChecked: 'CC'
    },
    {
      id: 1,
      fieldName: 'rblPaymentType',
      label: `Bonifico bancario`,
      inputType: 'radio',
      value: 'CC',
      valueIfChecked: 'BT'
    }
  ]
  Vue.prototype.dynFormConfigAbbConditions = [
    {
      id: 0,
      fieldName: 'cbTermsAndConditions',
      label: `Accetto <a target="_blank" href="/termini-e-condizioni"><b>i termini e le condizioni</b></a> del servizio di LearK`,
      inputType: 'checkbox',
      valueIfChecked: 'true',
      validators: [
        {
          type: 'required',
          message: `Se non si accettano i termini e le condizioni del servizio non è possibile proseguire con l'abbonamento.`
        }
      ]
    },
    {
      id: 1,
      fieldName: 'cbGdprInfo',
      label: `Dichiaro di aver letto il modulo <a target="_blank" href="/pdf/Leark_Informativa_GDPR.pdf">REG UE 2016/679</a>`,
      inputType: 'checkbox',
      valueIfChecked: 'true',
      validators: [
        {
          type: 'required',
          message: `Se non si dichiara di aver preso visione dell'art.13-14 GDPR non è possibile proseguire con l'abbonamento.`
        }
      ]
    }
  ]

  Vue.prototype.dynFormConfigContactRequest = [
    { id: 0, fieldName: 'txtContactRequestFullName', label: 'Nome completo', validators: [{ type: 'required' }] },
    {
      id: 1,
      fieldName: 'txtContactRequestEmail',
      label: 'Email',
      validators: [
        { type: 'required' },
        {
          type: 'regex',
          regex:
            /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/,
          message: 'Campo non formattato correttamente'
        }
      ]
    },
    {
      id: 2,
      fieldName: 'txtContactRequestPhone',
      label: 'Telefono'
    },
    {
      id: 3,
      fieldName: 'txtContactRequestCompany',
      label: 'Azienda',
      validators: [{ type: 'required' }]
    },
    {
      id: 4,
      fieldName: 'txtContactRequestMessage',
      label: 'Messaggio',
      inputType: 'textarea',
      validators: [{ type: 'required' }]
    },
    {
      id: 5,
      fieldName: 'chkContactRequestPrivacy',
      label: `Ai sensi del regolamento (UE) 2016/679 acconsento all'uso dei miei dati personali per le finalità dei servizi di LearK srl<br>
  <a target="_blank" href="/privacy">Clicca qui per l'informativa privacy completa</a>`,
      inputType: 'checkbox',
      valueIfChecked: 'true',
      validators: [
        {
          type: 'required',
          message: `Se non si autorizza il trattamento dei dati personali non è possibile proseguire`
        }
      ]
    },
    {
      id: 6,
      fieldName: 'chkContactRequestRecaptcha',
      inputType: 'recaptcha',
      label: 'recaptcha',
      validators: [{ type: 'required', message: 'Captcha non valido' }]
    }
  ]

  Vue.prototype.dynFormConfigRegisterConditions = [
    {
      id: 0,
      fieldName: 'rblRegisterCompanyPrivacy',
      label: `Ai sensi del regolamento (UE) 2016/679 acconsento all'uso dei miei dati personali per le finalità dei servizi di LearK srl<br>
  <a target="_blank" href="/privacy">Clicca qui per l'informativa privacy completa</a>`,
      inputType: 'checkbox',
      valueIfChecked: 'true',
      validators: [
        {
          type: 'required',
          message: `Se non si autorizza il trattamento dei dati personali non è possibile proseguire`
        }
      ]
    },
    {
      id: 1,
      fieldName: 'rblRegisterCompanyTerms',
      label: `Accetto <a target="_blank" href="/termini-e-condizioni">i termini e le condizioni</a> del servizio di LearK`,
      inputType: 'checkbox',
      valueIfChecked: 'true',
      validators: [
        {
          type: 'required',
          message: `Se non si accettano i termini e le condizioni del servizio non è possibile proseguire`
        }
      ]
    }
  ]

  Vue.prototype.dynFormConfigAbbSubscriber = [
    {
      id: 0,
      fieldName: 'txtBillingDataSeekerCompany',
      label: 'Ragione Sociale',
      validators: [{ type: 'required' }]
    },
    {
      id: 1,
      fieldName: 'txtBillingDataSeekerSDI',
      label: 'Codice SDI',
      validators: [
        { type: 'regex', regex: '^[A-Za-z0-9]{7}$', message: 'Campo non formattato correttamente' },
        {
          type: 'requiredOtherFields',
          requiredOtherFields: ['txtBillingDataSeekerPec'],
          message: 'Valorizzare almeno un campo a scelta tra SDI e PEC'
        }
      ]
    },
    {
      id: 2,
      fieldName: 'txtBillingDataSeekerVATNumber',
      label: 'Partita Iva',
      validators: [
        { type: 'regex', regex: '^[0-9]{11}$', message: 'Campo non formattato correttamente' },
        { type: 'required' }
      ]
    },
    {
      id: 3,
      fieldName: 'txtBillingDataSeekerTaxCode',
      label: 'Codice Fiscale',
      validators: [
        { type: 'required' },
        {
          type: 'regex',
          regex: '^[A-Za-z]{6}[0-9]{2}[A-Za-z]{1}[0-9]{2}[A-Za-z]{1}[0-9]{3}[A-Za-z]{1}$|^[0-9]{11}$',
          message: 'Campo non formattato correttamente'
        }
      ]
    },
    {
      id: 4,
      fieldName: 'txtBillingDataSeekerEmail',
      label: 'Email',
      validators: [
        { type: 'required' },
        {
          type: 'regex',
          regex:
            /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/,
          message: 'Campo non formattato correttamente'
        }
      ]
    },
    {
      id: 5,
      fieldName: 'txtBillingDataSeekerPec',
      label: 'PEC',
      validators: [
        {
          type: 'regex',
          regex: '^([\\w\\.\\-]+)@([\\w\\-]+)((\\.(\\w){2,})+)$',
          message: 'Campo non formattato correttamente'
        },
        {
          type: 'requiredOtherFields',
          requiredOtherFields: ['txtBillingDataSeekerSDI'],
          message: 'Valorizzare almeno un campo a scelta tra PEC e SDI'
        }
      ]
    },
    {
      id: 6,
      fieldName: 'txtBillingDataSeekerPhone',
      label: 'Telefono'
    },
    {
      id: 7,
      fieldName: 'txtBillingDataSeekerMobile',
      label: 'Cellulare'
    },
    {
      id: 7.5,
      fieldName: 'hfBillingAddressSeekerCountryCode',
      label: 'Codice Nazione',
      value: 'ITA',
      inputType: 'hidden',
      validators: [{ type: 'required' }]
    },
    {
      id: 8,
      fieldName: 'txtBillingAddressSeekerCountry',
      label: 'Nazione',
      value: 'Italia',
      validators: [
        { type: 'required' },
        {
          type: 'regex',
          regex: '^[i|I]talia$',
          message: `Per ora possono registrarsi solo aziende con sede in Italia.<br/>Contattare il supporto per ulteriori informazioni.`
        }
      ],
      typeahead: {
        bloodhoundSource: country,
        valueProp: 'ISO3Code',
        labelProp: 'Label',
        sortProp: 'Label',
        valueField: 'hfBillingAddressSeekerCountryCode'
      }
    },
    { id: 9, fieldName: 'skip', skip: true },
    { id: 10, fieldName: 'txtBillingAddressSeekerStreet', label: 'Indirizzo', validators: [{ type: 'required' }] },
    {
      id: 10.5,
      fieldName: 'hfBillingAddressSeekerDistrictCode',
      label: 'Codice Provincia',
      inputType: 'hidden'
    },
    {
      id: 12,
      fieldName: 'txtBillingAddressSeekerDistrict',
      label: 'Provincia',
      validators: [{ type: 'required' }],
      typeahead: {
        bloodhoundSource: district,
        valueProp: 'Code',
        labelProp: 'Label',
        sortProp: 'Label',
        valueField: 'hfBillingAddressSeekerDistrictCode'
      }
    },
    {
      id: 13,
      fieldName: 'txtBillingAddressSeekerCity',
      label: 'Città',
      validators: [{ type: 'required' }],
      inputClass: ['cities-typeahead'],
      typeahead: {
        bloodhoundSource: cities,
        valueProp: 'ZipCode',
        labelProp: 'Label',
        sortProp: 'Label',
        valueField: 'txtBillingAddressSeekerPostalCode',
        filterField: 'hfBillingAddressSeekerDistrictCode'
      }
    },
    {
      id: 14,
      fieldName: 'txtBillingAddressSeekerPostalCode',
      label: 'Codice postale',
      validators: [
        { type: 'required' },
        { type: 'regex', regex: '^[0-9]{5}$', message: 'Il formato del campo Codice Postale non è corretto' }
      ]
    },
    {
      id: 15,
      fieldName: 'jsonSectorData',
      inputType: 'hidden',
      validators: [{ type: 'required' }],
      inputClass: ['cities-typeahead']
    },
    {
      id: 16,
      fieldName: 'txtDescription',
      inputType: 'sector',
      label:
        'Descrizione della tua attività<br /><span class="text-light"> Fornisci una breve descrizione della tua attività aziendale per aiutarci a personalizzare e ottimizzare le nostre ricerche per te.<span>',
      validators: [{ type: 'custom' }]
    }
  ]

  Vue.prototype.dynFormConfigSeekerDescription = [
    {
      id: 1,
      fieldName: 'jsonSectorData',
      inputType: 'hidden',
      validators: [{ type: 'required' }],
      inputClass: ['cities-typeahead']
    },
    {
      id: 2,
      fieldName: 'txtDescription',
      inputType: 'sector',
      label:
        'Descrizione della tua attività<br /><span class="text-light"> Fornisci una breve descrizione della tua attività aziendale per aiutarci a personalizzare e ottimizzare le nostre ricerche per te.<span>',
      validators: [{ type: 'custom' }]
    }
  ]

  Vue.prototype.dynFormConfigCompanyRegister = [
    { id: 0, fieldName: 'txtRegisterCompanyFirstname', label: 'Nome referente', validators: [{ type: 'required' }] },
    {
      id: 1,
      fieldName: 'txtRegisterCompanyLastname',
      label: 'Cognome referente',
      validators: [{ type: 'required' }]
    },
    {
      id: 2,
      fieldName: 'txtRegisterCompanyCompanyName',
      label: 'Ragione sociale',
      validators: [{ type: 'required' }]
    },

    {
      id: 3,
      fieldName: 'txtRegisterCompanyVatNumber',
      label: 'Partita Iva',
      validators: [
        { type: 'regex', regex: '^[0-9]{11}$', message: 'Il formato del campo P.Iva non è corretto' },
        {
          type: 'remote',
          method: 'post',
          url: '/api/v1/utilities/isVATNumberFree',
          valueParam: 'vat', // Se non specificato utilizza 'value'
          extraParam: { excludeloggeduser: true, appUserId: () => EventBus.appUserId }, // Nel caso di servizi preesistenti permette di specificare eventuali altri parametri obbligatori TODO: rendere dinamico
          // responseEval: 'd', // Ci si aspetta una risposta true/false. Se il servizio restituisce un oggetto complesso permette di testare il valore desiderato.
          message: 'La partita Iva è già utilizzata'
        }
      ]
    },
    {
      id: 4,
      fieldName: 'txtRegisterCompanyEmail',
      label: 'Email',
      validators: [
        { type: 'required' },
        {
          type: 'regex',
          regex:
            /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/,
          message: 'Il formato del campo non è corretto.'
        },
        {
          type: 'remote',
          method: 'post',
          url: '/api/v1/utilities/isEmailAndUsernameFree',
          valueParam: 'mail', // Se non specificato utilizza 'value'
          extraParam: { excludeloggeduser: true, iscontactmail: false, appUserId: () => EventBus.appUserId }, // Nel caso di servizi preesistenti permette di specificare eventuali parametri obbligatori TODO: rendere dinamico
          // responseEval: 'd', // Ci si aspetta una risposta true/false. Se il servizio restituisce un oggetto complesso permette di testare il valore desiderato.
          message: 'Indirizzo Email già utilizzato'
        }
      ]
    },
    {
      id: 5,
      fieldName: 'txtRegisterCompanyEmailConfirm',
      label: 'Conferma Email',
      validators: [
        { type: 'required' },
        {
          type: 'regex',
          regex:
            /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/,
          message: 'Il formato del campo non è corretto.'
        },
        {
          type: 'equalOtherFields',
          equalOtherFields: ['txtRegisterCompanyEmail'],
          message: 'I due campi Email sono differenti'
        }
      ]
    },

    {
      id: 6,
      fieldName: 'txtRegisterCompanyPassword',
      inputType: 'password',
      label: 'Password',
      validators: [
        { type: 'required' },
        {
          type: 'regex',
          regex: '^.{6,20}$',
          message: 'La password deve essere compresa tra 6 e 20 caratteri'
        }
      ]
    }
  ]
